import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { ITankStyle } from "../../common/models/TankStyle";
import TankStyleDataService from "../../services/tank-style-service/TankStyleDataService";

export type UseTankStylesParameters = {

} & BaseUseQueryParameters<ITankStyle[]>;

export function useTankStyles({
    onError,
    onSuccess
}: UseTankStylesParameters) {
    return useQuery<ITankStyle[], RestError>(
        keys.tankStyles(),
        ({ signal }) => {
            return TankStyleDataService.getTankStyles(signal);
        },
        {
            onError: onError,
            onSuccess: onSuccess,
        }
    );
}
